var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4501 19.2303C16.6855 16.326 19.1101 14.0179 21.9891 14.0001C24.8419 13.9824 27.171 16.2696 27.4596 19.1423C27.6375 20.9123 28.1298 22.5428 29.1183 24.2784C30.1216 26.04 29.0494 28.5 27.0405 28.5H16.9404C14.9263 28.5 13.878 25.9785 14.8922 24.2172C15.8633 22.5306 16.3113 20.9411 16.4501 19.2303Z",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12V13",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30C24 31.1046 23.1046 32 22 32C20.8954 32 20 31.1046 20 30",
    stroke: "#172664",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAlert);
export default __webpack_public_path__ + "static/media/btn_alert.d28ff74d718683ae23bf19bd9d4ec03e.svg";
export { ForwardRef as ReactComponent };